export default "__VITE_ASSET__41d91127__"